import { API_BASE_URL, TIMEOUTS, requestJson } from './http';

export const fetchEvidenceCapabilities = () =>
  requestJson(`${API_BASE_URL}/api/v1/evidence-intelligence/capabilities`, {
    fallbackMessage: 'Failed to load evidence intelligence capabilities',
  });

// Runs a model-backed grade server-side (backend allows up to 45s of model
// time), so this gets the LLM deadline rather than the default.
export const analyzeEvidence = ({ content, analysisType = 'journal-coach', context = {} }) =>
  requestJson(`${API_BASE_URL}/api/v1/evidence-intelligence/analyze`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ content, analysis_type: analysisType, context }),
    timeout: TIMEOUTS.llm,
    fallbackMessage: 'Evidence intelligence failed',
  });
